export enum PackageName {
  INSTANT = 'instant',
  STANDARD = 'standard',
  EXPRESS = 'express',
}
